var map = {
	"./menu-arena-active1.png": 88422,
	"./menu-assets-active1.png": 34854,
	"./menu-backpack-active1.png": 98719,
	"./menu-friend-active1.png": 22359,
	"./menu-home-active1.png": 3098,
	"./menu-mining-active1.png": 70331,
	"./menu-rank-active1.png": 5365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86358;